// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--light .spectrum-IllustratedMessage-illustration {\n  color: rgb(179, 179, 179);\n  fill: currentColor;\n  stroke: currentColor;\n}\n", ""]);
// Exports
module.exports = exports;
